import {Option, option} from "ts-option";
import {store} from "../../navigation/ReduxProvider";
import LeadStatus from "../../model/lead/LeadStatus";

/**
 * Gets Lead status.
 * @param {string} id Lead status identifier to get.
 * @returns {Option<LeadStatus>} lead status.
 */
export function getLeadStatus(id: string): Option<LeadStatus> {
	const statuses = store.getState().leadStatus.leadStatuses.getOrElse([]);
	const status = statuses.filter((ls) => ls.id === id);
	return option(status[0]);
}
